import _ from 'lodash';
import { useMsal, } from '@azure/msal-react';
import { useEffect, useState, useMemo } from "react";
import TenantApi from "../../api/tenant/tenant-api-factory";
import { arrayAny } from '../../utils/arrayUtils';
import { filterActiveTenants, filterInactiveTenants } from '../../utils/tenantUtils';
import LoadingAnimation from '../loading/loading';

import { NewTenantModal } from '../tenants/new-tenant-modal';
import { AddDCModal } from '../tenants/add-dc-modal';
import { TenantTiles } from '../tenants/tenant-tiles';

export const PropertyTenantsTab = ({ propertyDocument }) => {

    const { instance, inProgress, accounts } = useMsal();
    const tenantApi = useMemo(() => new TenantApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    const [showTenantDelete, setShowTenantDelete] = useState(false);
    const [showNewTenantModal, setShowNewTenantModal] = useState(false);
    const [tenants, setTenants] = useState([]);
    const [addDC, setAddDC] = useState(false);
    const [fetchComplete, setFetchComplete] = useState(false);
    const [statusFilter, setStatusFilter] = useState('active'); // 'all' | 'active' | 'inactive'

    useEffect(() => {

        async function fetchData() {
            if (propertyDocument && propertyDocument.property && propertyDocument.property.landlordOrOwner && propertyDocument.property.landlordOrOwner.parent &&
                propertyDocument.property.landlordOrOwner.parent.id &&
                !fetchComplete
            ) {
                const result = _.sortBy(await tenantApi.list(
                    propertyDocument.property.landlordOrOwner.parent.id,
                    propertyDocument.property.landlordOrOwnerId,
                    propertyDocument.id
                ), 'displayName');
                setFetchComplete(true);
                setTenants(result);
            }
        }
        fetchData();
    }, [propertyDocument, tenantApi, fetchComplete])

    const handleSave = async newTenant => {

        newTenant.companyId = propertyDocument.property.landlordOrOwner.parent.id;
        newTenant.landlordOrOwnerId = propertyDocument.property.landlordOrOwner.id;
        newTenant.propertyId = propertyDocument.id;

        const result = await tenantApi.create(newTenant);

        console.log("Save Tenant", result);
        setTenants([...tenants, result])
        setShowNewTenantModal(false);
    };

    const handleAddBulkDebitCredit = async data => {
        const result = await tenantApi.addBulkDebitCredit(data);

        // Update only the tenants that were modified
        setTenants(prevTenants => {
            return prevTenants.map(tenant => {
                // Find if there's an updated version of this tenant
                const updatedTenant = result.find(t => t.id === tenant.id);
                // If there is an update, use it; otherwise keep the existing tenant
                return updatedTenant || tenant;
            });
        });

        setAddDC(false);
    };

    return (

        <div className="tab-pane fade" id="nav-pills-tab-tenants" key={"Tenants"}>

            <NewTenantModal handleCancel={() => setShowNewTenantModal(false)} handleSave={handleSave} show={showNewTenantModal} />
            <AddDCModal handleCancel={() => setAddDC(false)} handleSave={handleAddBulkDebitCredit} show={addDC} tenants={tenants} />

            <h3 className="mt-10px">Tenants</h3>

            <div className='mb-3 d-flex align-items-center gap-3'>
                <div className='dropdown'>
                    <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
                        Action&nbsp;&nbsp;<span className="caret"></span>
                    </button>
                    <div className="dropdown-menu">
                        <div className='dropdown-item link-like-div' onClick={() => setShowNewTenantModal(true)}><i className='fa fa-plus fa-lg'></i>&nbsp;&nbsp;Add Tenant</div>
                        <div className='dropdown-item link-like-div' onClick={() => setShowTenantDelete(v => !v)}><i className='fa fa-trash fa-lg'></i>&nbsp;&nbsp;{`${showTenantDelete ? 'Cancel Delete' : 'Delete Tenants'}`}</div>
                        {showTenantDelete &&
                            <div className='dropdown-item link-like-div'><i className='fa fa-trash fa-lg'></i>&nbsp;&nbsp;Delete Selected Tenants</div>}
                        <div className="dropdown-divider"></div>
                        <div className='dropdown-item link-like-div' onClick={() => setAddDC(true)} ><i className='fa fa-sterling-sign fa-lg'></i>&nbsp;&nbsp;Add Bulk Debit/Credit</div>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <label htmlFor="statusFilterTenants" className="form-label mb-0">Show</label>
                    <select id="statusFilterTenants" className="form-select form-select-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                        <option value="all">All</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </div>
            </div>

            <div className={'pos-customer'} >
                <div className="pos-content">
                    <div className="pos-content-container" options={{ suppressScrollX: true }}>
                        <div className="product-row">
                            {arrayAny(tenants) && fetchComplete && <TenantTiles tenants={(
                                () => {
                                    let list = tenants ?? [];
                                    if (statusFilter === 'active') {
                                        list = filterActiveTenants(list);
                                    } else if (statusFilter === 'inactive') {
                                        list = filterInactiveTenants(list);
                                    }
                                    return list;
                                }
                            )()} />}
                            {!fetchComplete && <LoadingAnimation />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}